import { SupportChannelAssignType, SupportChannelRuleType } from '@business/entities/SupportChannel';

export function getRuleTypeTitle(type: SupportChannelRuleType) {
  switch (type) {
    case SupportChannelRuleType.email:
      return 'Email';
    case SupportChannelRuleType.wildcard_email:
      return 'Wild Card Email';
    case SupportChannelRuleType.org:
      return 'Organization';
  }
}

export function allRuleTypes() {
  return [SupportChannelRuleType.email, SupportChannelRuleType.wildcard_email, SupportChannelRuleType.org];
}

export function getAssignTypeTitle(type: SupportChannelAssignType) {
  switch (type) {
    case SupportChannelAssignType.user:
      return 'User';
    case SupportChannelAssignType.channel_rule:
      return 'Channel Rule';
  }
}

export function allAssignTypes() {
  return [SupportChannelAssignType.channel_rule];
}
